/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({ serverPages = null }) => {
  const { instance } = useContext(AppContext);
  const pipTimeout = instance?.expConfiguration?.['apollo.pip.timeout'];
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path={routes.product.path}
          element={channel === 'mobile'
            ? <routes.productMobile.component pipTimeout={pipTimeout} />
            : <routes.product.component pipTimeout={pipTimeout} />}
        />
        <Route exact path={routes.configuratorProjects.path} element={<routes.configuratorProjects.component />} />
        <Route exact path={routes.findYourFlooring.path} element={<routes.findYourFlooring.component />} />
        <Route exact path={routes.home.path} element={<routes.home.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {
  serverPages: PropTypes.shape({})
};
